<template lang="pug">
    div
        .lock-screen(v-if="lockScreen")
        v-card(pa-3)
            //- .title(v-if="posSaleType === 2") N° de orden de Compra
            //- v-text-field.title(solo
            //-     v-if="posSaleType === 2"
            //-     placeholder="Ingrese N° de Orden de Compra en caso de existir una"
            //-     v-model="OC"
            //-     mask="#######"
            //-     @input="setOC()")
            v-divider(v-if="posSaleType === 2")
            pay(
                :saleCreditNotes='saleCreditNotes' 
                v-if="!(totalToPay <= 0)"
                @clean-form="cleanForm"
                )
            v-divider
            v-card-text
                payment-details
            v-card-text
                v-card(color="grey" pa-1)
                    v-card-text
                        v-layout(row wrap)
                            .headline Pago autorizado:
                                v-text-field.headline(solo readonly
                                :mask="mixCurrencyMask(totalPaid, 12)"
                                prefix="$"
                                v-model="totalPaid")
                            v-spacer
                            .headline Vuelto:
                                v-text-field.headline(solo readonly
                                    :mask="mixCurrencyMask(change, 12)"
                                    prefix="$"
                                    v-model="change")
            v-card-actions
                v-layout(row wrap)
                    v-flex(md-3 )
                        v-btn.white--text(  color="orange accent-2"
                        @click="goStep2") Volver a facturas pendientes
                    v-flex(md-2 v-show="showSwitchPartial")
                        v-switch.swclass(v-model="allowPartial" label="pago parcial")
                    v-flex(md-2)
                        v-btn.ml-5.white--text( 
                            v-show="allowPartial"
                            color="info"
                            round
                            @click='confirmSale' 
                            ) Pago Parcial
                    v-flex(md-2)
                        v-btn.white--text#btn-confirm-sale(
                            color="blue darken-3" 
                            round
                            @click='confirmSale' 
                            @keyup.enter='confirmSale'
                            :disabled="!(totalToPay <= 0)"
                            ) Confirmar Pago  
</template>

<script>
// Components:
import Pay from './paymentMethod/PaymentMethod'
import PaymentDetails from './detail/PaymentDetails'
import { mapState, mapActions, mapGetters } from 'vuex'
import { ANNUL_SALE_ACTION } from '@/components/SnackbarModal/SnackbarActions'
import { cloneDeep } from 'lodash'

// Mixins:
import CurrencyUtils from '@/mixins/CurrencyUtils'

//Services:
import { timeout } from '@/services/AsyncUtils'
import { CLEAN_TICKET } from '@/components/SnackbarModal/SnackbarActions'
import CustomerPaymentService from '@/services/API/customerPayment'
import CustomerReceivablePaymentService from '@/services/API/customerReceivablePayment'
import mockCustomerPayment from '@/services/API/mock-data/mockCustomerPayment'
export default {
    name: 'payment',
    props: {
        saleCreditNotes: {
            type: Array,
            default: () => [],
        },
        copies: {
            type: Number,
            default: 1,
        },
    },
    data: function() {
        return {
            OC: '',
            posSaleType: 2,
            allowPartial: false,
            lockScreen: false,
        }
    },
    computed: {
        isPaymentPartially: function() {
            return this.allowPartial
        },
        /**
         * Show Button for paying partially
         */
        showPartialPayment: function() {
            return this.arrayPayments.length === 0 && this.totalToPay > 0
                ? true
                : false
        },
        showSwitchPartial: function() {
            return this.isSelectedOneInvoice()
        },
        // hiddenPartialPayment: function(){
        //     return (this.totalToPay == 0)
        //         ? true
        //         : false
        // },
        /**
         * Vuex states and getters
         */
        ...mapState('AuthModule', {
            posCashDeskId: state => state.cash_desk_id,
            user: 'user',
            TBK: 'tbk',
        }),
        ...mapState('CustomerPaymentModule', {
            total: state => state.total,
            payment: state => state.payment,
            paymentDetail: state => state.paymentDetail,
            invoiceSelected: state => state.invoiceSelected,
            arrayPayments: state => state.arrayPayments,
        }),
        ...mapState('CustomerModule', {
            customerData: state => state.customerData,
        }),
        ...mapGetters('CustomerPaymentModule', {
            change: 'change',
            allDataSet: 'allDataSet',
            totalToPay: 'totalToPay',
            totalPaid: 'totalPaid',
            roundingLaw: 'roundingLaw',
        }),
        ...mapState('SnackbarModalModule', {
            showSnackbar: 'showSnackbar',
            responseConfirm: 'responseConfirm',
        }),
        ...mapState('SessionModule', ['isTransbankIntegrated']),
        /** end Vuex states and getters */
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('CustomerPaymentModule', {
            resetCashDeskState: 'resetCashDeskState',
            submitSale: 'submitSale',
            clearPayment: 'clearPayment',
            printDTE: 'printDTE',
            reprintDTE: 'reprintDTE',
            resetSale: 'resetSale',
            setPurchaseOrder: 'setPurchaseOrder',
            setStep: 'setStep',
            clearArrayPayments: 'clearArrayPayments',
            clearPayment: 'clearPayment',
            clearInvoiceSelected: 'clearInvoiceSelected',
            setArrayPayments: 'setArrayPayments',
        }),

        setOC() {
            this.setPurchaseOrder(this.OC)
        },

        async confirmSale() {
            this.lockScreen = true
            this.initSnackbar(
                this.fillSnack(
                    'info',
                    'Preparando Pago',
                    'Confirmando datos pago',
                    true
                )
            ) // Showing info + loading snackbar
            if (!this.arrayPayments || !this.arrayPayments.length) return
            if (
                this.arrayPayments.filter(p => [2, 3].includes(p.paymentMethod))
                    .length > 1
            ) {
                console.log(1)
                this.lockScreen = false
                this.resetSnackbarState()
                this.initSnackbar({
                    typeMessage: 'error',
                    message: {
                        title: 'Error en Pagos',
                        body:
                            'Sólo puede registrarse un pago con' +
                            'débito o uno con crédito',
                    },
                    timeout: 0,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                })
                return
            }

            let tbk = this.arrayPayments.find(p =>
                [2, 3].includes(p.paymentMethod)
            )
            let tbkData = null

            // check only numbers
            function onlyNumbers(str) {
                return /^\d+$/.test(str)
            }

            // check if transbank detail has carrier identifier
            const hasTransbankData      = !! tbk
            const hasTransbankVoucher   = hasTransbankData && tbk.paymentDetail.voucher !== null
            const hasOnlyNumbers        = hasTransbankData && onlyNumbers(tbk.paymentDetail.voucher)
            const isCarrier             = hasTransbankData && hasTransbankVoucher && !hasOnlyNumbers
            // let isCarrier = !!tbk && !onlyNumbers(tbk.paymentDetail.voucher)
            console.log({ tbk })
            console.log({ hasTransbankData, hasTransbankVoucher, hasOnlyNumbers })

            // check if required transbank machine
            if (tbk && this.isTransbankIntegrated && !isCarrier) {
                try {
                    this.initSnackbar({
                        typeMessage: 'info',
                        message: {
                            title: 'Conectando a Transbank',
                            body: 'Por favor opere POS de transbank',
                        },
                        timeout: 0,
                        showProgress: true,
                        showCloseBtn: true,
                        closeBtnMessage: '',
                    }) // Showing info + loading snackbar
                    tbkData = await this.TBK.sale(
                        this.invoiceSelected[0].id,
                        tbk.payment,
                        3
                    )
                } catch (error) {
                    console.log(2, error)
                    this.lockScreen = false
                    this.resetSnackbarState()
                    this.initSnackbar({
                        typeMessage: 'error',
                        message: {
                            title: 'Error de Transbank',
                            body: error,
                        },
                        timeout: 0,
                        showProgress: false,
                        showCloseBtn: true,
                        closeBtnMessage: 'cerrar',
                    })
                    return
                }
            }
            // if (tbk && !tbkData) return
            if (tbkData) {
                console.log('TRANSBANK_DATA', tbkData)
                let arrayPayments = cloneDeep(this.arrayPayments)
                let idx = arrayPayments.findIndex(p =>
                    [2, 3].includes(p.paymentMethod)
                )
                arrayPayments[idx] = {
                    payment: tbk.payment,
                    paymentDetail: {
                        voucher: tbkData.operation_number,
                        shares_number: tbkData.shares_number,
                        terminal_id: tbkData.terminal_id || '',
                        authorization_code: tbkData.authorization_code || 0,
                    },
                    paymentMethod: tbk.paymentMethod,
                }
                this.setArrayPayments(arrayPayments)
            }

            this.initSnackbar({
                typeMessage: 'info',
                message: {
                    title: 'Registrando Pago',
                    body: 'Guardando venta en la base de datos',
                },
                timeout: 0,
                showProgress: true,
                showCloseBtn: true,
                closeBtnMessage: '',
            }) // Showing info + loading snackbar

            let submitArray = this.getDataForSend()
            let response = await CustomerPaymentService.invoicePayment(
                //FIXME: ONLY FOR WORK
                submitArray
            )
            //let response = mockCustomerPayment.cheque
            if (response.status === 'success') {
                this.lockScreen = false
                this.initSnackbar(
                    this.fillSnack(
                        'success',
                        'Exito',
                        'Pago registrado exitosamente'
                    )
                )
                this.$emit('success')
                console.log(response, 'response payment')
                let totalpagado = this.getTotalPayment(response.payments)
                console.log(totalpagado, 'getTotalPayment')
                console.log(this.invoiceSelected, 'invoicesSelected')
                const res = await CustomerReceivablePaymentService.print(
                    response.customer_receivable_payment_id,
                    this.invoiceSelected,
                    this.arrayPayments.some(pay => pay.paymentMethod === 1)
                        ? this.roundingLaw
                        : 0,
                    totalpagado,
                    this.arrayPayments,
                    this.copies
                )
                this.resetSnackbarState()
                this.initSnackbar(
                    this.fillSnack(
                        'info',
                        'Éxito',
                        'Se genero un comprobante de pago.'
                    )
                )
                this.clearArrayPayments()
                this.clearPayment()
                this.clearInvoiceSelected()
                //this.setTimeout(() => this.$router.go(), 3000)
                this.setStep(1)
                /** if payment partially */
                if (this.isPaymentPartially) {
                    // this.showSnackPaymentPartial()
                    // this.setStep(2)
                    // this.setStep(1)//FIXME: ONLY FOR WORK
                    //this.$router.go() //FIXME: ONLY FOR WORK
                } else {
                    //this.setStep(1)//FIXME: ONLY FOR WORK
                    //this.$router.go() //FIXME: ONLY FOR WORK
                }
            } else if (response.status === 'error') {
                this.lockScreen = false
                console.log(response, 'response')

                let msg =
                    response.errors != null ? response.errors : response.message
                this.resetSnackbarState()
                this.initSnackbar(this.fillSnack('error', 'Error', msg))
            }
        },
        /* Jano NEW methods */
        /**
         *
         */
        getDataForSend() {
            let submitArray = {}
            const prependZeros = (num, len) => {
                const length = num.length
                const diff = len - length
                if (diff > 0) {
                    for (let i = 1; i <= diff; i++) {
                        num = '0' + num
                    }
                }
                return num
            }
            submitArray.pos_cash_desk_id = this.posCashDeskId
            submitArray.g_user_id = this.user.id
            submitArray.sl_customer_id = this.getCustomerId()
            console.log(this.isSelectedOneInvoice(), 'oneinovice chek')
            if (this.isSelectedOneInvoice()) {
                submitArray.receivables = [
                    {
                        sl_customer_receivable_pending_id: this.getInvoiceId(),
                        amount: parseInt(this.getInvoiceAmount()),
                    },
                ]
            } else {
                submitArray.receivables = this.getMultipleInvoices()
            }

            submitArray.payments = this.getArrayPayments()
            console.log(submitArray, 'arrayfinal for sending')
            return submitArray
        },
        /**
         *
         */
        getCustomerId() {
            let invoice = this.invoiceSelected
            return invoice[0].sl_customer_id
        },
        /**
         *
         */
        getInvoiceId() {
            let invoice = this.invoiceSelected
            return invoice[0].id
        },
        /**
         *
         */
        getInvoiceAmount() {
            if (this.isPaymentPartially) {
                let payments = this.getArrayPayments()
                const countPayments = payments.length
                let amounts = payments.map(payment => {
                    let newObj = {}
                    newObj.amount = payment.amount
                    return newObj
                })
                let total = amounts.reduce((collect, val) => {
                    return collect + val
                })
                return total.amount
            } else {
                return this.total
            }
        },
        /**
         *
         */
        getArrayPayments() {
            let long = this.arrayPayments.length
            return this.arrayPayments.map(pay => {
                let subformat = {}
                subformat.pos_payment_type_id = pay.paymentMethod
                subformat.amount = pay.payment
                if (pay.paymentMethod === 1) {
                    // this.checkIfPayingPartially()
                    //     ? subformat.amount = parseInt(pay.payment) - parseInt(0)
                    //     :
                    subformat.amount =
                        parseInt(pay.payment) - parseInt(this.change)
                    if (long == 1) {
                        //solo paga con efectivo
                        //if rounding is negative
                        if (Math.sign(this.roundingLaw) == -1) {
                            subformat.amount =
                                parseInt(pay.payment) -
                                parseInt(this.change) +
                                Math.abs(this.roundingLaw)
                        } else if (Math.sign(this.roundingLaw) == 1) {
                            subformat.amount =
                                parseInt(pay.payment) -
                                parseInt(this.change) -
                                Math.abs(this.roundingLaw)
                        }
                        subformat.rounding = this.roundingLaw
                    } else {
                        subformat.rounding = 0
                    }
                }
                console.log({ pay })
                if (pay.paymentMethod === 2 || pay.paymentMethod === 3) {
                    subformat.voucher_number = pay.paymentDetail.voucher
                    // subformat.voucher_number = parseInt(
                    //     pay.paymentDetail.voucher
                    // )
                    subformat = Object.assign(subformat, pay.paymentDetail)
                }
                if (pay.paymentMethod === 4) {
                    const formatCheckPayment = ({ paymentDetail }) => {
                        let obj = {}
                        console.log(paymentDetail)
                        obj.account_number = parseInt(
                            paymentDetail.accountNumber
                        )
                        obj.g_bank_id = paymentDetail.bankId
                        obj.charge_date = paymentDetail.chargeDate
                        obj.pos_payment_check_type_id =
                            paymentDetail.checkTypeId
                        obj.plaza = parseInt(paymentDetail.plaza)
                        obj.serial_number = parseInt(paymentDetail.serialNumber)
                        return obj
                    }
                    let checkdata = { ...subformat, ...formatCheckPayment(pay) }
                    return checkdata
                }
                if (pay.paymentMethod === 7) {
                    subformat.bank_document_number =
                        pay.paymentDetail.bank_document_number
                }
                if (pay.paymentMethod === 8) {
                    subformat.sl_sale_credit_note_id =
                        pay.paymentDetail.sl_sale_credit_note_id
                }
                console.log(subformat, 'subformat')
                return subformat
            })
        },
        checkIfPayingPartially() {
            if (this.showPartialPayment || this.hiddenPartialPayment) {
                return false
            } else {
                return true
            }
        },
        getMultipleInvoices() {
            return this.invoiceSelected.map(invoice => {
                let arrInvoice = {}
                arrInvoice.sl_customer_receivable_pending_id = invoice.id
                arrInvoice.amount = invoice.receivable
                return arrInvoice
            })
        },
        isSelectedOneInvoice() {
            return this.invoiceSelected.length === 1 ? true : false
        },
        /* End Jano New methods */
        cleanForm() {
            this.resetCashDeskState()
            this.$emit('clean-form')
        },
        annulSale() {
            this.setMessageConfirmSnack(ANNUL_SALE_ACTION)
            let payload = this.fillSnack(
                'warning',
                '¿Deseas anular la venta?',
                'Una vez anulada la venta no podras acceder a la información'
            )
            this.initSnackbar(payload)
        },
        goStep2() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Volver')
            let payload = this.fillSnack(
                'warning',
                '¿Deseas volver a listado de pagos?',
                'Todos los pagos ingresados serán perdidos'
            )
            this.initSnackbar(payload)
        },
        showSnackPaymentPartial() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Ir a Facturas cliente')
            let payload = this.fillSnack(
                'info',
                '¿Deseas volver a factura del cliente?',
                'Presiona ir Facturas cliente , si no cancelar y volverás a búsqueda usuario'
            )
            this.initSnackbar(payload)
        },
        /*
         */
        getTotalPayment(arr) {
            let amount = arr.map(r => {
                return parseInt(r.amount)
            })
            return amount.reduce((acc, r) => acc + r)
        },
    },
    watch: {
        responseConfirm: async function(val) {
            if (val == 'Volver') {
                this.resetSale()
                // this.cleanForm()
                this.resetSnackbarState()
                this.setStep(2)
                this.$emit('goback')
            }
        },
    },
    components: { PaymentDetails, Pay },
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    //     this.allowPartial = false
    // },
    // beforeUpdate: function(){...},
    // updated: function(){
    //     this.allowPartial = false
    // },
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.swclass {
    margin-top: -0px;
}
.lock-screen {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 12;
    background-color: rgba($color: #aaaaaa, $alpha: 0.5);
    cursor: wait;
}
</style>
